module.exports = __webpack_public_path__ + "img/people.bd038856.png";